import { convexQuery } from '@convex-dev/react-query';
import { api } from '@repo/backend/_generated/api';
import { createFileRoute } from '@tanstack/react-router';
import { Home } from '@/features/home';

export const Route = createFileRoute('/_authenticated/')({
    head: () => ({ meta: [{ title: 'Home | promote.fun' }] }),
    loader: async ({ context }) => {
        // Block render until active campaigns are cached — splash stays up during this.
        // Ended campaigns prefetch in background (below the fold).
        await context.queryClient.ensureQueryData(
            convexQuery(api.campaigns.getHomeActiveCampaigns, {
                paginationOpts: { numItems: 15, cursor: null },
            })
        );
        void context.queryClient.prefetchQuery(
            convexQuery(api.campaigns.getHomeEndedCampaigns, {
                paginationOpts: { numItems: 15, cursor: null },
            })
        );
        // clipperStats + myProfile require auth — gated by useSplashGate in the component
    },
    component: Home,
});
